
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ServerDataSource } from 'angular2-smart-table';
import { HttpService } from './common/http.service';
import { Person, PersonData, } from '../interfaces/person';
import { HttpParams } from '@angular/common/http';
import { get, has, isArray, isNull, isObject, isUndefined, mapValues, omit, pickBy } from 'lodash';
import { User } from '../interfaces/auth/users';
import { Assignment, AssignmentData } from '../interfaces/assignment';
import { prepRecordForApi } from '../utils/utils.service';
import { SalaryStructureConfig } from '../interfaces/salary-structure';
@Injectable()
export class AssignmentService extends AssignmentData {
  private readonly url: string;

  constructor(
    private api: HttpService,
  ) {
    super();
    this.url = 'assignments';

  }

  get gridDataSource(): ServerDataSource {
    return this.api.getServerDataSource(`${this.api.API_BASE_URL}/${this.url}?populate=*`);
  }

  list(pageNumber: number, pageSize: number, query: string = '' ): Observable<Person[]> {
    let params: HttpParams = new HttpParams()
      .append('populate', '*');

    if (pageSize > 0) {
      params = params.append('limit', `${pageSize}`);
    }

    if (pageNumber > 0) {
      params = params.append('offset', `${(pageNumber - 1) * pageSize}`);
    }

    // If you have filters, sorts, etc. in query, convert them to v5 format
    // Example: ?where[title][$contains]=foo&order=createdAt:desc
    if (query) {
      // You may need to parse and append query params here
      // For now, assume query is already in v5 format
      params = params.append('where', query);
    }

    return this.api.get(this.url, { params }).pipe(map(res => {
      return res.data || res;
    }));
  }
  

  listAll(): Observable<Person[]> {
    let params: HttpParams = new HttpParams()
      .append('limit', '-1')
      .append('offset', '0')
      .append('sort', 'startDate:desc');

    params = params.append('populate', '*');

    return this.api.get(this.url, { params }).pipe(map(res => {
      return res.data || res;
    }));
  }

  get(id: any): Observable<Person> {
    return this.api.get(`${this.url}/${id}`, {
      params: new HttpParams().append('populate', '*')
                              // .append('populate[assignments][populate]', '*')
    }).pipe(map(res => res.data || res));
  }

  create(record: any): Observable<Person> {
    let params: HttpParams = new HttpParams()
      .append('populate', '*');

    const recordToSave = {
      ...prepRecordForApi(record),
      personId: record.person?.documentId ?? record.person,
      salaryStructure: record['salary-structure'],
      fromDate: record.startDate,
      // 'salary-structure': undefined
    };

    return this.api.post('payroll/salary-structure-assignments', {data: recordToSave}, { params })
      .pipe(map(res => {
        return res.data;
      }));
  }


  update(record: Person | any): Observable<Person> {
    let params: HttpParams = new HttpParams()
      .append('populate', '*');

    const recordToSave = prepRecordForApi(record);

    return this.api.put(`payroll/salary-structure-assignments/${record.documentId}`, {data: recordToSave}, { params })
      .pipe(map(res => {
        return res.data;
      }));
  }

  // archive(person: Person, date: Date, user: User): Observable<Person> {
  //   return this.api.put(`${this.url}/${person.documentId}`, {
  //     data: {
  //       archivedOn: date,
  //       archivedBy: user,
  //     },
  //   });
  // }
  
  
  // unarchive(person: Person): Observable<Person> {
  //   return this.api.put(`${this.url}/${person.documentId}`, {
  //     data: {
  //       archivedOn: null,
  //       archivedBy: null,
  //     },
  //   });
  // }


  delete(id: any): Observable<any> {
    return this.api.delete(`${this.url}/${id}`);
  }
}
